import { render, staticRenderFns } from "./_foresightPage.vue?vue&type=template&id=9b2cfa54&scoped=true"
import script from "./_foresightPage.vue?vue&type=script&lang=js"
export * from "./_foresightPage.vue?vue&type=script&lang=js"
import style0 from "./_foresightPage.vue?vue&type=style&index=0&id=9b2cfa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2cfa54",
  null
  
)

export default component.exports